import { setup } from 'xstate';

export type CreateProjectState = 'projectDetails' | 'contactDetails' | 'submission' | 'success';

export type CreateProjectEvent = 
    | { type: 'NEXT' } 
    | { type: 'BACK' } 
    | { type: 'SUBMIT' };

export const createProjectMachine = setup({
    types: {
        events: {} as CreateProjectEvent,
    }
}).createMachine(
    {
        id: 'createProjectForm',
        initial: 'projectDetails',

        states: {
            projectDetails: {
                on: {
                    NEXT: {
                        target: 'contactDetails',
                    },
                },
            },
            contactDetails: {
                on: {
                    NEXT: {
                        target: 'submission',
                    },
                    BACK: {
                        target: 'projectDetails',
                    },
                },
            },
            submission: {
                on: {
                    BACK: {
                        target: 'contactDetails',
                    },
                    SUBMIT: {
                        target: 'success',
                    },
                },
            },
            success: {
                type: 'final',
            },
        },
    }
);
